var map = {
	"./fivetigers_en.png": "bgoN",
	"./fivetigers_esp.png": "+wQO",
	"./fivetigers_th.png": "/dxg"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "W8EW";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas ^\.\/fivetigers_.*\.png$
// module id = W8EW
// module chunks = 1